var QueryParams = /** @class */ (function () {
    function QueryParams(search) {
        this.query = new URLSearchParams(window.location.search);
        this.search = search;
        this.handleSorting();
        this.handleSearch();
    }
    QueryParams.prototype.handleSorting = function () {
        if (!this.query.get('orderby') && typeof ACP_Sorting !== 'undefined') {
            this.query.set('orderby', ACP_Sorting.orderby);
        }
        if (!this.query.get('order') && typeof ACP_Sorting !== 'undefined') {
            this.query.set('order', ACP_Sorting.orderby);
        }
    };
    QueryParams.prototype.handleSearch = function () {
        this.query.set('ac-rules', JSON.stringify(this.search.getRules()));
    };
    QueryParams.prototype.get = function () {
        return this.query;
    };
    return QueryParams;
}());
export default QueryParams;
